export const CHARACTER_SHEET_LAYOUT = "角色四视图设定板：一张正方形图片，2×2等大分区，左上正面、右上左侧面、左下背面、右下右侧面。四格是同一角色在同一时点的不同视角，脸型、年龄、发型、体型、服装、配饰完全一致；不是四个人，也不是四个剧情阶段。每格全身从头顶到鞋底完整入画，统一比例和视线高度，平视、自然站立、双臂略离身体；侧面与背面按真实转向展示。统一柔和棚光、浅灰纯色背景，不安排剧情动作、场景或临时手持道具，不加文字、视角标签、水印。";

export function characterSheetPrompt(name: string, visualDescription: string) {
  return `${CHARACTER_SHEET_LAYOUT}\n角色：${name}。\n${visualDescription}`;
}

export function reusableCharacterLook(candidate?: { version?: number; visualDescription?: string; prompt: string }) {
  return candidate?.version === 2 ? candidate.visualDescription ?? '' : '';
}
